import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getTransactionTasks = createAsyncThunk(
  "Tasks/getTransactionTasks",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/transactions/contracts/get-all-tasks-by-contract/${data.id}?startingDueDate=${data.startingDueDate?data.startingDueDate:""}&endingDueDate=${data.endingDueDate?data.endingDueDate:""}&status=${data.status?data.status:""}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

